(function () {
  'use strict';

  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    } catch (error) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function updateShippingEstimate(root) {
    var subtotal = Number(root.getAttribute('data-cart-subtotal-cents'));
    if (!Number.isFinite(subtotal)) return;

    var shipping = 0;
    var shippingAmount = root.querySelector('[data-pizzannu-shipping-amount]');
    var estimatedTotal = root.querySelector('[data-pizzannu-estimated-total]');

    if (shippingAmount) {
      shippingAmount.textContent = shipping === 0 ? 'FREE' : formatMoney(shipping);
    }
    if (estimatedTotal) {
      estimatedTotal.textContent = formatMoney(subtotal + shipping);
    }
  }

  function updateAll() {
    document.querySelectorAll('[data-pizzannu-shipping-estimate]').forEach(updateShippingEstimate);
  }

  document.addEventListener('DOMContentLoaded', updateAll);
  document.addEventListener('dispatch:cart-drawer:refresh', function () {
    window.setTimeout(updateAll, 50);
  });

  document.addEventListener('click', function (event) {
    var link = event.target.closest('.pizzannu-subscribe-link');
    if (!link) return;

    var popup = document.querySelector('pop-up');
    if (popup && typeof popup.open === 'function') {
      event.preventDefault();
      popup.open();
    }
  });

  var observer = new MutationObserver(function () {
    window.clearTimeout(observer.timer);
    observer.timer = window.setTimeout(updateAll, 50);
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
